import React from 'react';
import ModuleRoute from 'holocron-module-route';

const childRoutes = () => [
  <ModuleRoute key="/" path="/">
    <ModuleRoute path="en-us/banking">
      <ModuleRoute moduleName="axp-page-wrapper">
        <ModuleRoute exact={true} path="wealth" moduleName="axp-financial-planning-home" />
        <ModuleRoute path="wealth">
          <ModuleRoute exact={true} path="spendsmart" moduleName="axp-financial-planning-home" />
        </ModuleRoute>
        <ModuleRoute exact={true} path="slwealth" moduleName="axp-financial-planning-home" />
        <ModuleRoute path="slwealth">
          <ModuleRoute exact={true} path="spendsmart" moduleName="axp-financial-planning-home" />
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>
  </ModuleRoute>,
];

export default childRoutes;
